// SYMMETRIC LIMIT — sync with:
//   - src/domains/buyer/data/sbp_banks.py (Python SSOT — validation gate)
//   - miniapp/src/lib/sbpBanks.ts (this file — display only)
// The backend `UpdateSbpRequest` validator is the single enforcement gate;
// this TS copy is display-only. Drift = UX bug (server 422s), not security.

/**
 * SBP_BANKS — full NSPK SBP participant list (member_id → display name).
 * 206 entries, mirrored from src/domains/buyer/data/sbp_banks.py.
 * Used for display only. The backend validates the bank_id on PUT /profile/sbp.
 */
export const SBP_BANKS: Record<string, string> = {
  // Top 15 (by popularity) — mirrors sbp_banks.py TOP_BANK_IDS order
  "100000000111": "Сбербанк",
  "100000000004": "Т-Банк",
  "100000000008": "Альфа-Банк",
  "100000000005": "ВТБ",
  "100000000015": "Газпромбанк",
  "100000000007": "Райффайзенбанк",
  "100000000022": "Россельхозбанк",
  "100000000030": "Промсвязьбанк",
  "100000000032": "МКБ",
  "100000000010": "Росбанк",
  "100000000025": "Совкомбанк",
  "100000000012": "Банк Открытие",
  "100000000013": "Почта Банк",
  "100000000020": "Ак Барс Банк",
  "100000000016": "Банк Уралсиб",
  // Extended list (IDs 001-087)
  "100000000001": "Банк Санкт-Петербург",
  "100000000002": "Русский Стандарт",
  "100000000003": "ОТП Банк",
  "100000000006": "ЮниКредит Банк",
  "100000000009": "Ренессанс Кредит",
  "100000000011": "Хоум Банк",
  "100000000014": "Банк ДОМ.РФ",
  "100000000017": "Новикомбанк",
  "100000000018": "Транскапиталбанк",
  "100000000019": "БКС Банк",
  "100000000021": "Банк Зенит",
  "100000000023": "МТС Банк",
  "100000000024": "СДМ-Банк",
  "100000000026": "Металлинвестбанк",
  "100000000027": "Банк Кубань Кредит",
  "100000000028": "РНКБ",
  "100000000029": "Запсибкомбанк",
  "100000000031": "Банк Левобережный",
  "100000000033": "Кредит Европа Банк",
  "100000000034": "Абсолют Банк",
  "100000000035": "Банк Центр-инвест",
  "100000000036": "Примсоцбанк",
  "100000000037": "Дальневосточный Банк",
  "100000000038": "Банк Приморье",
  "100000000039": "ВБРР",
  "100000000040": "Энергобанк",
  "100000000041": "УБРиР",
  "100000000042": "Яндекс Банк",
  "100000000043": "Тинькофф Страхование",
  "100000000044": "Банк АВЕРС",
  "100000000045": "Банк Акцепт",
  "100000000046": "Банк Александровский",
  "100000000047": "Банк Ассоциация",
  "100000000048": "Банк ВБРР",
  "100000000049": "Банк Возрождение",
  "100000000050": "Банк Солидарность",
  "100000000051": "Банк Форштадт",
  "100000000052": "Банк Хлынов",
  "100000000053": "БыстроБанк",
  "100000000054": "Гарант-Инвест",
  "100000000055": "ГПБ Инвестиции",
  "100000000056": "Датабанк",
  "100000000057": "Дом.РФ",
  "100000000058": "ИКБР ЯРИНТЕРБАНК",
  "100000000059": "Инвестторгбанк",
  "100000000060": "КБ Долинск",
  "100000000061": "КБ Хакасский муниципальный банк",
  "100000000062": "Кредитбанк",
  "100000000063": "Меткомбанк",
  "100000000064": "Морской банк",
  "100000000065": "НБД-Банк",
  "100000000066": "Нейва",
  "100000000067": "Норвик Банк",
  "100000000068": "Прио-Внешторгбанк",
  "100000000069": "РосДорБанк",
  "100000000070": "Саровбизнесбанк",
  "100000000071": "СКБ-банк",
  "100000000072": "Тольяттихимбанк",
  "100000000073": "Углеметбанк",
  "100000000074": "Экономбанк",
  "100000000075": "Экспобанк",
  "100000000076": "АТБ",
  "100000000077": "Банк Интеза",
  "100000000078": "Банк Оранжевый",
  "100000000079": "Кошелев-банк",
  "100000000080": "ПСКБ",
  "100000000081": "ТКБ Банк",
  "100000000082": "Тосненский",
  "100000000083": "Уралфинанс",
  "100000000084": "Фора-банк",
  "100000000085": "Банк Синара",
  "100000000086": "Озон Банк",
  "100000000087": "Вайлдберриз Банк",
  // NSPK additions (IDs 088-205)
  "100000000088": "НКО ЮМани",
  "100000000089": "АКБ АВАНГАРД",
  "100000000090": "Банк ФИНАМ",
  "100000000091": "КБ ЮНИСТРИМ",
  "100000000092": "Газэнергобанк",
  "100000000093": "Кредит Урал Банк",
  "100000000094": "Земский банк",
  "100000000095": "КБ Новый век",
  "100000000096": "НС Банк",
  "100000000097": "Инго Банк",
  "100000000098": "АКБ Алмазэргиэнбанк",
  "100000000099": "ПНКО ЭЛПЛАТ",
  "100000000100": "Банк Екатеринбург",
  "100000000101": "БАНК СНГБ",
  "100000000102": "ЧЕЛЯБИНВЕСТБАНК",
  "100000000103": "АБ РОССИЯ",
  "100000000104": "КБ РостФинанс",
  "100000000105": "КБ Модульбанк",
  "100000000106": "Банк Агророс",
  "100000000107": "КБ Пойдём!",
  "100000000108": "Эс-Би-Ай Банк",
  "100000000109": "ЧЕЛИНДБАНК",
  "100000000110": "АКИБАНК",
  "100000000112": "КБ Москоммерцбанк",
  "100000000113": "АКБ Алеф-Банк",
  "100000000114": "НИКО-БАНК",
  "100000000115": "ПроБанк",
  "100000000116": "ИК Банк",
  "100000000117": "БАНК ОРЕНБУРГ",
  "100000000118": "ГОРБАНК",
  "100000000119": "Банк Саратов",
  "100000000120": "КБ АРЕСБАНК",
  "100000000121": "ББР Банк",
  "100000000122": "Первый Дортрансбанк",
  "100000000123": "Тойота Банк",
  "100000000124": "КБ ЭНЕРГОТРАНСБАНК",
  "100000000125": "МБ Банк",
  "100000000126": "УРАЛПРОМБАНК",
  "100000000127": "Банк 131",
  "100000000128": "Тимер Банк",
  "100000000129": "КБ СИНКО-БАНК",
  "100000000130": "ГУТА-БАНК",
  "100000000131": "Банк Венец",
  "100000000132": "Банк ИТУРУП",
  "100000000133": "АКБ Энергобанк",
  "100000000134": "ЮГ-Инвестбанк",
  "100000000135": "КБ ЛОКО-Банк",
  "100000000136": "Снежинский",
  "100000000137": "Русьуниверсалбанк",
  "100000000138": "СИБСОЦБАНК",
  "100000000139": "АКБ ЕВРОФИНАНС МОСНАРБАНК",
  "100000000140": "МП Банк",
  "100000000141": "Банк Развитие-Столица",
  "100000000142": "Первый Инвестиционный Банк",
  "100000000143": "АКБ ТЕНДЕР-БАНК",
  "100000000144": "МОСКОМБАНК",
  "100000000145": "Кубаньторгбанк",
  "100000000146": "Автоторгбанк",
  "100000000147": "Банк Объединенный капитал",
  "100000000148": "Газтрансбанк",
  "100000000149": "АКБ НРБанк",
  "100000000150": "Нацинвестпромбанк",
  "100000000151": "Банк РЕСО Кредит",
  "100000000152": "ТАТСОЦБАНК",
  "100000000153": "КБЭР Банк Казани",
  "100000000154": "Банк МБА-МОСКВА",
  "100000000155": "КБ СТРОЙЛЕСБАНК",
  "100000000156": "КБ РУСНАРБАНК",
  "100000000157": "Кузнецкбизнесбанк",
  "100000000158": "Инбанк",
  "100000000159": "АКБ Трансстройбанк",
  "100000000160": "ИШБАНК",
  "100000000161": "АКБ СЛАВИЯ",
  "100000000162": "Банк Кремлевский",
  "100000000163": "АКБ МЕЖДУНАРОДНЫЙ ФИНАНСОВЫЙ КЛУБ",
  "100000000164": "Банк Заречье",
  "100000000165": "Томскпромстройбанк",
  "100000000166": "Северный Народный Банк",
  "100000000167": "КБ Крокус-Банк",
  "100000000168": "Банк Финсервис",
  "100000000169": "Севергазбанк",
  "100000000170": "УКБ Новобанк",
  "100000000171": "СОЦИУМ-БАНК",
  "100000000172": "УКБ Белгородсоцбанк",
  "100000000173": "Прио-Внешторгбанк",
  "100000000174": "МС Банк Рус",
  "100000000175": "АКБ Солид",
  "100000000176": "ЦентроКредит",
  "100000000177": "РЕАЛИСТ БАНК",
  "100000000178": "НК Банк",
  "100000000179": "БАНК МОСКВА-СИТИ",
  "100000000180": "АКБ Держава",
  "100000000181": "Банк ИПБ",
  "100000000182": "Банк Национальный стандарт",
  "100000000183": "АКБ Ланта-Банк",
  "100000000184": "банк Раунд",
  "100000000185": "КБ ВНЕШФИНБАНК",
  "100000000186": "Банк Кузнецкий",
  "100000000187": "АИКБ Енисейский объединенный банк",
  "100000000188": "Банк БЖФ",
  "100000000189": "Роял Кредит Банк",
  "100000000190": "Цифра банк",
  "100000000191": "банк Элита",
  "100000000192": "Банк Ставр",
  "100000000193": "Банк ЧБРР",
  "100000000194": "НКО Мобильная карта",
  "100000000195": "Хайс Банк",
  "100000000196": "ФИНСТАР БАНК",
  "100000000197": "ЦМРБанк",
  "100000000198": "Банк Точка",
  "100000000199": "Промсельхозбанк",
  "100000000200": "Банк Пэйджин",
  "100000000201": "МТС Деньги",
  "100000000202": "ЖИВАГО БАНК",
  "100000000203": "Плайт",
  "100000000204": "РОКЕТБАНК",
  "100000000205": "БАНК МСКБ",
};

/**
 * TOP_BANK_IDS — curated 17 most popular bank member_ids for the initial
 * bank picker list (shown when search is empty).
 * Mirrors TOP_BANK_IDS from src/domains/buyer/data/sbp_banks.py.
 */
export const TOP_BANK_IDS: readonly string[] = [
  "100000000111", // Сбербанк
  "100000000004", // Т-Банк
  "100000000008", // Альфа-Банк
  "100000000005", // ВТБ
  "100000000015", // Газпромбанк
  "100000000007", // Райффайзенбанк
  "100000000022", // Россельхозбанк
  "100000000030", // Промсвязьбанк
  "100000000032", // МКБ
  "100000000010", // Росбанк
  "100000000025", // Совкомбанк
  "100000000012", // Банк Открытие
  "100000000013", // Почта Банк
  "100000000020", // Ак Барс Банк
  "100000000016", // Банк Уралсиб
  "100000000086", // Озон Банк
  "100000000087", // Вайлдберриз Банк
] as const;
